import commonActions from "./actions";

const initialState = {
  showInlineErrors:[],
  showCloseTabModal:false,
  showCloseEditingTabModal:false,
  updateDetailsClicked:false,
  showSidebar: true,
  buttonLoader: false,
  showPaymentConfirmationModal:false, 
  draftButtonLoader: false,
  alert: { status: null, show: false, message: null },
  pageLoader: false,
  dashBoardpageLoader: false,
  isVerifyOtpModalOpen:false,
  showRedirectToHomeModal:false,
  showModal: {
    show: false,
    type: null,
    method: null,
    data: null,
  },
  clickable:false
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
        case commonActions.SET_INLINE_ERRORS:
      return {
        ...state,
        showInlineErrors: action.payload,
      };
        case commonActions.SHOW_CLOSE_TAB_MODAL:
      return {
        ...state,
        showCloseTabModal: action.payload,
      };
              case commonActions.SHOW_CLOSE_EDITING_TAB_MODAL:
      return {
        ...state,
        showCloseEditingTabModal: action.payload,
      };
      case commonActions.SHOW_PAYMENT_CONFIRMATION_MODAL:
      return {
        ...state,
        showPaymentConfirmationModal: action.payload,
      };
        case commonActions.SET_SHOW_REDIRECT_TO_HOME_MODAL:
      return {
        ...state,
        showRedirectToHomeModal: action.payload,
      };
    case commonActions.SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: action.payload,
      };
    case commonActions.SET_BUTTON_LOADER:
      return {
        ...state,
        buttonLoader: action.payload,
      };
          case commonActions.IS_VERIFY_OTP_MODAL_OPEN:
      return {
        ...state,
        isVerifyOtpModalOpen: action.payload,
      };
          case commonActions.SET_UPDATE_DETAILS:
      return {
        ...state,
        updateDetailsClicked: action.payload,
      };
    case commonActions.SET_ALERT:
      return {
        ...state,
        alert: action.payload,
      };
    case commonActions.SET_DRAFT_BUTTON_LOADER:
      return {
        ...state,
        draftButtonLoader: action.payload,
      };
    case commonActions.SET_PAGE_LOADER:
      return {
        ...state,
        pageLoader: action.payload
      }
    case commonActions.SET_DASHBOARD_PAGE_LOADER:
      return {
        ...state,
        dashBoardpageLoader: action.payload
      }
    case commonActions.SET_SHOW_MODAL:
      return {
        ...state,
        showModal: action.payload
      }  
    case commonActions.SET_CLICKABLE:
      return {
        ...state,
        clickable: action.payload
      }  
    default:
      return state;
  }
};

export default commonReducer;
